import React from 'react';

import GenericHeader from '@common-components/pageHeader/GenericHeader';
import Text from '@common-components/form/Text';
import Button from '@common-components/button/Button';
import { INPUT_TYPES } from '@common-components/form/constants/fieldTypes';
import useSelfDesignationOtpRole from '../../hooks/useSelfDesignationOtpRole';

export const RenderOneMatchFoundAlreadyDesignated = ({ backToDashboard, clearData, environmentLinks }) => {
    const { role } = useSelfDesignationOtpRole();
    return(
        <div className='gi-panel desktop:grid-col-fill tablet:grid-col-fill mobile-lg:grid-col-12 grid-col-12' id="ede-search-result__found-records">
            <div className="member__name">
                <GenericHeader
                    id='result__header'
                    text='selfDesignation.search.searchResult.modal.header.oneMatchFoundAlreadyDesignated'
                    tag='h3'
                    headerClassName={['mobile:grid-col-12 tablet:grid-col-fill']}
                />
            </div>
            <div className='grid-row flex-row' id='ede-search-result__member-info'>
                <Text { ...{
                    id: 'one_match_found_already_designated',
                    display: 'block',
                    textReplacements:{phone: environmentLinks?.PHONE || ''},
                    text: `selfDesignation.${role}.search.searchResult.modal.message.oneMatchFoundAlreadyDesignated`
                } }/>
            </div>
            <div className='grid-col-12 action__btn__wrapper padding-b-0'>
                <Button
                    {...{
                        id: 'clear-btn',
                        name: 'clearBtn',
                        type: INPUT_TYPES.BUTTON,
                        outerClass: ['margin-b-20', 'margin-r-10', 'display-inline'],
                        classes: ['gi-button__secondary'],
                        btnText: 'selfDesignation.search.action-btn.cancel',
                        handleClick: clearData
                    }}
                />
                <Button
                    {...{
                        id: 'back-to-dashboard-btn',
                        name: 'backToDashboard',
                        type: INPUT_TYPES.BUTTON,
                        outerClass: ['margin-b-20', 'display-inline'],
                        classes: ['gi-button__primary'],
                        btnText: 'selfDesignation.search.action-btn.backToDashboard',
                        handleClick: backToDashboard
                    }}
                />
            </div>
        </div>
    );
};



